import { InputTextarea } from "primereact/inputtextarea";
import { Tag } from "primereact/tag";
import styled from "styled-components";

export const StyledNotesTextarea = styled(InputTextarea)`
  &.p-inputtextarea::placeholder {
    font-size: 14px;
    color: #706f7b;
  }
`;

export const StyledSectionContainer = styled.div`
  border: 1px solid #e2e2e4;
  border-radius: 12px;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  gap: 16px;
  p {
    color: #706f7b;
  }
  .gray {
    color: #858490;
  }
  .shadow {
    box-shadow: 0px 5px 10px 0px rgba(18, 12, 96, 0.06),
      0px 2px 2px 0px rgba(17, 12, 96, 0.1);
  }
  .black {
    color: #000000;
  }
  .purple {
    color: #4f46e5;
  }
  ul li::marker {
    color: #4f46e5;
  }
  ul li {
    color: #706f7b;
  }
`;

export const StyledPaymentTypeTag = styled(Tag)`
  background-color: #4f46e5 !important;
  color: white !important;
  font-size: 11px !important;
  padding: 2px 8px !important;
  border-radius: 6px;
`;

export const AddPaymentRecordButton = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  border: 2px dashed #e2e2e4;
  border-radius: 12px;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
  p {
    color: #706f7b;
  }

  &:hover {
    border-color: var(--primary-color);
  }
`;

export const PaymentRecordItem = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border: 1px solid #e2e2e4;
  border-radius: 12px;
  background-color: #ffffff;
  margin-bottom: 0.5rem;
`;
